import { Children, isValidElement } from 'react'
import Markdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ChatChart } from './ChatChart'
import { parseChartSpec } from './chart-spec'

/** Only navigable web links; no model-provided HTML, embedded media, or executable URLs. */
export function conversationUrl(url: string): string | undefined {
  return /^https?:\/\/[^\s<>]+$/iu.test(url) ? url : undefined
}

const components: Components = {
  a: ({ href, children }) => href
    ? <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
    : <>{children}</>,
  img: ({ alt }) => <span>{alt}</span>,
  table: ({ children }) => <div className="table-scroll" role="region" tabIndex={0} aria-label="جدول گفت‌وگو"><table className="table">{children}</table></div>,
  // Replace the entire pre, so a figure never ends up nested inside a code or pre element.
  pre: ({ children }) => {
    const child = Children.toArray(children)[0]
    if (isValidElement<{ className?: string; children?: unknown }>(child) && child.props.className === 'language-chart' && typeof child.props.children === 'string') {
      const spec = parseChartSpec(child.props.children)
      if (spec) return <ChatChart spec={spec} />
    }
    return <pre dir="ltr">{children}</pre>
  },
}

/** Shared by streamed replies, stored messages, and archived conversations. */
export function ConversationText({ text }: { text: string }) {
  return <div className="conversation-text" dir="auto">
    <Markdown remarkPlugins={[remarkGfm]} components={components} skipHtml urlTransform={conversationUrl}>{text}</Markdown>
  </div>
}
